import { UserEnums } from "../enums";

export const userRoleDict = [
  {
    value: UserEnums.Role.Admin,
    label: "admin",
    info: "",
  },
  {
    value: UserEnums.Role.Editor,
    label: "editor",
    info: "",
  },
  {
    value: UserEnums.Role.Viewer,
    label: "viewer",
    info: "",
  },
];
